export function dedupeRequestId(requestId) {
  var _requestId$split$;
  if (requestId == null) {
    return requestId;
  }
  return (_requestId$split$ = requestId.split(',')[0]) == null ? void 0 : _requestId$split$.trim();
}
//# sourceMappingURL=dedupeRequestId.js.map